import {Row, Typography} from "antd"

import notFound from '../../assets/images/not_found.svg'

const NotFound = () => {
  return <Row style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh'}}>
    <img src={notFound} alt="Page not found" style={{height: '200px', width: 'auto'}} />
    <Typography.Title level={4} className="mt-2">Oops! Content not found</Typography.Title>
  </Row>;
};

export default NotFound;
